import axios from "axios";

const configJson = require("../config.json");
const APIBASE = new URL(configJson.apiBase);
const APIURL = APIBASE + "api/file/ticket";

/**
 * Request for a ticket to download a basket.
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export default async function ticketRequest() {
  return await axios.get(APIURL, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("Bearer")
    }
  });
}
